import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useContext } from 'react';
import useStyles from './PccStepSelect.styles';
import clsx from 'clsx';
import Icon from '../Icon/Icon';
import { CHOOSE_AN_OCCASION } from '../../utils/constants';
import { SiteContext } from '../../utils/common';
const PccStepSelect = (props) => {
    const { label, selectedValue, handleClick, currentStep, completedStep, isActive, showAllOccasions, isManualAddressSelection, isShowDayPicker, isAddressFieldTouched, handleEditClick, isPCCEditFeatureEnabled, } = props;
    const { classes } = useStyles({ showAllOccasions, isManualAddressSelection });
    const isStepCompleted = completedStep || (!isActive && !!selectedValue);
    const isStepActive = isActive || (selectedValue && !completedStep);
    const showInactiveLabel = !isActive && !completedStep && !selectedValue;
    const { isFlyingFlowers } = useContext(SiteContext);
    const renderStepIcon = () => {
        if (completedStep) {
            return _jsx(Icon, { icon: "check_circle", className: clsx(classes.iconSize, classes.iconColor) });
        }
        if (!(!isShowDayPicker && currentStep === 1)) {
            return _jsxs("span", { className: classes.stepNumber, children: [currentStep, "."] });
        }
        return null;
    };
    const getDisplayText = () => {
        if (!selectedValue || (isManualAddressSelection && !isFlyingFlowers) || (isPCCEditFeatureEnabled && !completedStep))
            return label;
        if (currentStep === 3 && !isPCCEditFeatureEnabled) {
            return CHOOSE_AN_OCCASION;
        }
        if (isPCCEditFeatureEnabled) {
            return _jsx("span", { className: classes.pccEditSelectedValueText, children: selectedValue });
        }
        return selectedValue;
    };
    return (_jsx("div", { className: clsx(classes.pccStepContainer, isStepCompleted && classes.stepCompleted, isStepActive && classes.activeStep, isAddressFieldTouched && currentStep === 2 && !completedStep
            ? classes.addressFieldTouched
            : classes.nonAddressFieldTouched), children: _jsx("button", Object.assign({ className: clsx(classes.pccStepSelectButton, isPCCEditFeatureEnabled && completedStep && classes.pccStepSelectButtonEdit), type: "button" }, ((!isManualAddressSelection || isFlyingFlowers) && { onClick: handleClick }), (isPCCEditFeatureEnabled &&
            currentStep &&
            completedStep && { onClick: () => handleEditClick === null || handleEditClick === void 0 ? void 0 : handleEditClick(currentStep) }), { children: _jsxs("h3", { className: clsx(classes.label, showInactiveLabel && classes.stepInActive, isStepActive && classes.activeStepLabel), children: [renderStepIcon(), _jsxs("span", { className: clsx(classes.selectedValueText, completedStep && classes.completedStepLabel, isPCCEditFeatureEnabled && classes.pccEditSelectedValue), children: [getDisplayText(), isPCCEditFeatureEnabled && selectedValue && completedStep && (_jsx(Icon, { icon: "edit", className: clsx(classes.iconSize, classes.editIconColor), fontSize: "small" }))] })] }) })) }));
};
export default PccStepSelect;
